import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Section from '@atlaskit/menu/section';
import { CheckboxGroupContext } from '../internal/context/checkbox-group-context';
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */
const DropdownItemCheckboxGroup = ({
  children,
  hasSeparator,
  id,
  isList,
  isScrollable,
  overrides,
  testId,
  title,
  // DSP-13312 TODO: remove spread props in future major release
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(CheckboxGroupContext.Provider, {
    value: id
  }, /*#__PURE__*/React.createElement(Section, _extends({
    hasSeparator: hasSeparator,
    id: id,
    isList: isList,
    isScrollable: isScrollable
    // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
    ,
    overrides: overrides,
    testId: testId,
    title: title
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, rest), children));
};
export default DropdownItemCheckboxGroup;